import { Box, Container, Typography, Divider } from "@mui/material";
import HomeNavbar from "../components/home-nav-bar";
import Footer from "../components/footer";

function PublishingGuidelines() {
  return (
    <Box>
      <HomeNavbar />
      <Container sx={{ mt: 8, mb: 8 }}>
        {/* Page Title */}
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Publishing Guidelines
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* Scope Section */}
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Scope
        </Typography>
        <Typography paragraph>
          The West African Journal of Life Sciences welcomes submissions in the following fields:
        </Typography>
        <Box component="ul" sx={{ pl: 4 }}>
          {[
            "Agricultural Science",
            "Food Science",
            "Biochemistry",
            "Plant Science and Botany",
            "Microbiology",
            "Zoology",
            "Nutrition",
            "Dietetics",
          ].map((field) => (
            <li key={field}>
              <Typography>{field}</Typography>
            </li>
          ))}
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* Author Guidelines */}
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Authors Guidelines
        </Typography>

        {/* Sections under Authors Guidelines */}
        {[
          { title: "Manuscript Preparation Guidelines", content: `
The title should be limited to 20 words or less, briefly describing the contents.
Author Information: Full names, affiliations, and contact details of all authors (including corresponding author).
Abstract: Summarize background, methods, results, and conclusions within 300 words.
Key Words: Up to six alphabetical keywords (excluding title words), including the subject category.
          ` },
          { title: "INTRODUCTION", content: `
The introduction should set the tone of the paper by providing a clear statement
of the study, the relevant literature on the study subject and the proposed approach or solution.
The introduction should be general enough to attract a reader's attention to a broad range of
scientific disciplines and should be in capital letters.`},
          { title: "MATERIALS AND METHODS", content: `
This section should provide a complete overview of the design of the
study. Detailed descriptions of materials or participants, comparisons, interventions, and types
of analysis should be mentioned. However, only new procedures should be described in detail;
previously published procedures should be cited, and important modifications of published
procedures should be mentioned briefly. Capitalize trade names and include the manufacturer's
name and address.`},
          { title: "RESULTS", content: `
State the results and draw attention in the text to important details shown in tables and
figures. Results and discussion should be presented in a separate sections. Detailed interpretation of data should precede each result presented in the table or figure.`},
          { title: "DISCUSSION", content: `
Point out the significance of the results in relation to the reasons for conducting the
work, and place them in the context of other work, comparing the results to other works that
has been carried out.`},
          { title: "ACKNOWLEDGEMENTS", content: `
The acknowledgments of people, grants, funds, etc. should be brief and
It (title) should be in capital letters.`},
          { title: "TABLES", content: `
Tables should be reduced to the simplest form and should not be used where text of
figures give the same information.  Standard error or less significant difference should be given to one place of decimals more than the mean.`},
          { title: "FIGURE LEGENDS", content: `
Graphics should be prepared using applications capable of generating high resolution GIF, TIFF, JPEG or Power point before pasting in the Microsoft Word manuscript file. Use Arabic numerals to designate
figures and upper-case letters for their parts (Figure 1). Begin each legend with a title and
include sufficient description so that the figure is understandable without reading the text of
the manuscript. Information given in legends should not be repeated in the text.`},
          { title: "REFERENCES", content: `
In the text, a reference identified by means of an author's name should be followed by the date of the reference in parentheses. When there are more than two authors, only the first author's name should be mentioned, followed by 'et al.'. In the event that an author cited has had two or more works published during the same year, the reference, both in the text and in the reference list, should be identified by a lower-case letter like 'a' and 'b' after the date to distinguish the works. Titles of journals should be abbreviated according to the form in the world list of scientific periodicals. If you cannot locate an authoritative abbreviation for a journal, and if it is not obvious how the title should be abbreviated, please cite the full title. Authors are fully responsible for the accuracy of the references.
Please adhere to the American Psychological Association (APA) referencing style, 7th Edition. Use the guidelines provided in the following link: /assets/APA_7th_Edition_Reference_Guide.pdf Ensure all sources are cited according to APA standards as outlined in the document.
Acceptance Letter, Proof and Publication
Authors are issued an Acceptance Certificate for Manuscripts that have been reviewed and accepted for publication by the editor undergo a final proofing process. Before publication, three galley proofs are sent to the corresponding author. Authors are expected to carefully review each proof and correct any minor typographical or grammatical errors. The corrected proofs should be returned promptly to the editorial office. Once the final proof is received, the manuscript is scheduled for inclusion in the next issue of the journal. The article is then published on the journal’s website, and a publication notice is sent to the corresponding author with links to both the issue and the article.`},
        ].map((section, idx) => {
  // Replace URLs with anchor tags
  const htmlContent = section.content.trim().replace(
  /((https?:\/\/|\/)[^\s]+)/g,
  (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
);


  return (
    <Box key={idx} sx={{ mb: 4 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {section.title}
      </Typography>
      <Typography
        component="div"
        paragraph
        whiteSpace="pre-line"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </Box>
  );
})}

        <Divider sx={{ my: 4 }} />

        {/* Other Guidelines */}
        {[
          { title: "Acceptance Letter, Proof and Publication", content: `
Authors are issued an Acceptance Certificate for
manuscripts that have been reviewed and accepted for publication by an editor.
Prior to publication, proof is sent to the corresponding author. Authors are advised to read the
proof and correct minor typographical or grammatical errors. Authors should promptly return
proof to the editorial office. Once proof is received at the editorial office, the manuscripts are
usually included in the next issue of the journal. The article will thereafter be published on the
faculty journal's website. After the article is made available on the journal's website, a
publication notice is sent to the corresponding author with links to the issue and article.` },
          { title: "Copyright", content: `
No article can be published unless accompanied by a signed publication
agreement, which serves as a transfer of copyright from author to the Journal. A publication
agreement may be obtained here. Only original papers will be accepted and copyright in
published papers will be vested in the publisher. It is the author’s responsibility to obtain
written permission to reproduce material that has appeared in another publication.` },
          { title: "Manuscript Submission", content: `
The West African Journal of Life Sciences (WAJLS) uses the Open Journal Systems (OJS) Editorial Management System developed by PKP for online manuscript submission and peer review. WAJLS strongly supports the Open Access model. A DOI provided by Cross-Ref will be assigned to all published articles.
Submission of a manuscript implies that:
-	The work has not been published previously (except as an abstract, a published lecture, or a thesis).
-	 The manuscript is not under consideration for publication elsewhere. 
-	Upon acceptance, the authors agree to the automatic transfer of copyright to the publisher.
-	All manuscripts, along with supporting documents, must be submitted through the journal’s submission link via the Authors’ Dashboard.` },
          { title: "Citations Manipulation", content: `
A manuscript should contain only relevant citations. It is unethical to condole self-citation to
increase and inclusion of citations not related or relevant to the work is strongly discouraged.
Plagiarism WAJLS see serious plagiarism as a serious offense and never acceptable. Plagiarism is the
first step in our review process. It is unethical and unacceptable for author(s) to publish
manuscripts describing essentially the same research in more than one journal of primary
publication. Manuscripts are rejected immediately if they are found to contain similar titles and
content already published in another journal. Eliminating manuscript with possible outcome is
the topmost goal of WAJLS. WAJLS abides with COPE guidelines in treating cases of
plagiarism, fabrication, and falsification of data.` },
          { title: "Plagiarism", content: `
WAJLS see serious plagiarism as a serious offense and never acceptable. Plagiarism is the
first step in our review process. It is unethical and unacceptable for author(s) to publish
manuscripts describing essentially the same research in more than one journal of primary
publication. Manuscripts are rejected immediately if they are found to contain similar titles and
content already published in another journal. Eliminating manuscript with possible outcome is
the topmost goal of WAJLS. WAJLS abides with COPE guidelines in treating cases of
plagiarism, fabrication, and falsification of data.` },
          { title: "Authorship", content: `
An author is someone who has made a significant contribution to the development of the
manuscript. The corresponding author should ensure that authors contributions are clearly highlighted under this section, and listed as coauthor. All authors should give the final approval for their manuscript to be submitted, final approval of the version to be published and are ready to take full responsibility of the published article.
The use of AI is prohibited by authors and can only be used for readability and English language. If the need arises to make changes in the authorship of a manuscript, only the corresponding author has the right to make a request to the chief editor or the managing editor. Changes will be done following the COPE standard.
Authors should disclose any potential conflict when submitting their manuscript. All sources of funding, financial support or any relationship that can influence the manuscript should be disclosed. It should also be stated if there is no conflict of interest.` },
          { title: "Confidentiality", content: `
Any manuscripts received for review must be treated as confidential documents. Reviewers must not share the review or information about the paper with anyone or contact the authors directly without permission from the editor. No material in a submitted manuscript should be used in reviewers research without the concern of the chief editor.` },
          { title: "Cover Letter", content: `
All manuscripts submission must be followed by a cover letter stating the significant of the manuscript, its uniqueness and any similar work previously reported by author(s). The letter should be address to the Editor-in-Chief or the managing editor/Editorial Assistant.` },
          { title: "Editorial and Peer Review Process", content: `
All submitted manuscripts undergo a double-blind review process before publication by competent and research experts in the journal’s editorial board. The identity of the author(s) of a manuscript is concealed from the selected reviewers. This is to remove any bias from selected reviewer. The review of manuscripts follows the usual process; A receipt of the manuscript(s) will be acknowledged for submission by an email from the editorial office. The manuscript will be reviewed to ensure a minimum criterion of WAJLS is met before it is sent to the external review and editors’ decision.
The manuscript will be reviewed by external reviewer using the outlined procedure:
Scope: Manuscript that does not meet the scope of WAJLS may be rejected.

English language: WAJLS publishes article only in English language. Manuscripts are checked for their structure, organization, correctness, and clarity of the language. Manuscripts that are difficult to comprehend will be sent back for modification to improve upon and resubmission.

Recent references: Numbers of references cited should be within the last five to ten with respect to life sciences. 

Reviewers are expected to evaluate the manuscript and provide useful comments, to enable the author(s) to improve the quality of the quality. 

Reviewers can rate the author’s manuscript based on the manuscript originality, contribution to the field, technical quality, clarity of presentation and depth of research. 

Suggestions for authors on manuscript reviewed should either be minor, moderate revision or major revision and specific reason should be provided if the manuscript is not suitable for further processing.

The comments and suggestions received from the reviewers are evaluated for differences and or contradictions. For a contradictory opinion, manuscripts are sent for further review to a third or fourth reviewer as the case maybe. 

All comments are sent to authors with the reviewer’s name concealed. The author makes corrections and resubmits a revised copy. The original manuscript, reviewer comments, and revised manuscripts are sent to the Editor-in-Chief who makes the decision based on the reviewers’ comments, example, accept in the current form, accept after minor corrections, accept after major correction, or revise and resubmit manuscript for review again. 

Manuscripts are immediately published and uploaded once accepted. Author should note that the total time taken to complete the review process is dependent on the availability of peer reviewers.` },
        ].map((section, idx) => (
          <Box key={idx} sx={{ mb: 4 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {section.title}
            </Typography>
            <Typography paragraph whiteSpace="pre-line">
              {section.content.trim()}
            </Typography>
          </Box>
        ))}

      </Container>
      <Footer/>
    </Box>
  );
};

export default PublishingGuidelines;
